import './styles/ChatOverView.scss';

import { FeedbackOutlined, LaunchOutlined } from '@mui/icons-material';
import { Button, Grid2 } from '@mui/material';
import { ShibUser } from '@thro-types/users';

import { useQueryState } from 'nuqs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useChatMutation } from 'api/hooks/useChatQuery';
import { ConfirmationDialog } from 'app/components';
import { translations } from 'locales/i18n';

import { ChatInterfaceInfoContainer } from './components/infoContainers/ChatInterfaceInfoContainer';

export const ChatOverview = ({ user }: { user: ShibUser }) => {
  const { t } = useTranslation();

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [chatToDelete, setChatToDelete] = useState<string | undefined>(undefined);
  const [activeChat, setActiveChat] = useQueryState('chatId', {
    defaultValue: ''
  });

  const { deletion } = useChatMutation();

  return (
    <Grid2 container size="grow" gap={2} flexDirection="column" alignItems="center">
      <ConfirmationDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        title={t(translations.pages.chat.dialogs.deleteChat.title())}
        onConfirm={async () => {
          if (!chatToDelete) return;
          await deletion.mutateAsync(chatToDelete);
          setDeleteDialogOpen(false);
          setChatToDelete(undefined);
          if (activeChat === chatToDelete) {
            setActiveChat('');
          }
        }}
      >
        {t(translations.pages.chat.dialogs.deleteChat.message())}
      </ConfirmationDialog>
      <ChatInterfaceInfoContainer
        leftAction={
          <Button
            href="https://collab.dvb.bayern/pages/viewpage.action?pageId=1104184301"
            target="_blank"
            startIcon={<FeedbackOutlined />}
            variant="outlined"
            size="large"
          >
            {t(translations.pages.chat.feedbackButton())}
          </Button>
        }
        rightAction={
          <Button
            href="https://ai.th-rosenheim.de"
            target="_blank"
            startIcon={<LaunchOutlined />}
            variant="contained"
            size="large"
          >
            {t(translations.pages.chat.chatPortalButton())}
          </Button>
        }
      />
    </Grid2>
  );
};
